import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { ChangePasswordPage } from 'src/pages/change-password';
import type { RouteProps } from 'src/types/router';

export const PASSWORD_CHANGE_ROUTE: RouteProps = {
  path: appRoutes.passwordChangeRequest.index,
  element: <ChangePasswordPage />,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
